<template>
    <div class="mt-4 mb-5">
        <div class="row">
            <div class="col-md-12">
                <div class="loader" v-if="loading"></div>
                <section id="logsTableSection" v-else>
                    <table class="table table-striped table-hover logs-table">
                        <thead>
                        <tr><th></th></tr>
                        </thead>
                        <tbody>
                        <tr v-for="(log, index) in logs" v-if="log !== ''" :key="'log_' + index">
                            <td>
                                <span class="badge-danger badge-pill badge mr-2">{{log.date}}</span>{{log.log}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
    import swal from 'sweetalert2';
    export default {
        name: "Logs",
        data () {
            return {
                logs: [],
                loading: false
            }
        },
        props: {
            account: Object,
            isCollaborator: Boolean,
            envType: String
        },
        watch: {
            account() {
                this.fetchLogs();
            },
            envType() {
                this.fetchLogs()
            }
        },
        async mounted () {
            this.fetchLogs();
        },
        methods: {
            fetchLogs () {
                if(this.selectedIP === '') {
                    return swal('Error!', 'Please select the plan!', 'error');
                }
                this.logs = [];
                $(".logs-table").DataTable().destroy();
                this.loading = true;
                this.$http.post('/utilities/server-logs', {
                    grant_type: "token",
                    ip: this.account.serverIP,
                    domain: (this.envType === 'staging') ? this.account.staging.domain : this.account.domain
                }).then(resp => {
                    var serverLogs = resp.data.logs.reverse();
                    let parsedLogs = [];
                    for(const log of serverLogs) {
                        const matches = log.match(/\[(.*?)\]/);
                        if(matches && matches.length === 2) {
                            parsedLogs.push({
                                log: log.substring(log.indexOf(']') + 2),
                                date: matches[1]
                            })
                        }
                    }
                    this.logs = parsedLogs;
                }).catch((e) => {
                    this.logs = [];
                    console.error(e);
                    // swal('Error!', 'Error in fetching the logs.', "error");
                }).finally(() => {
                    this.initDataTable();
                    this.loading = false;
                });
            },
            initDataTable () {
                /* eslint-disable */
                const self = this;
                $(document).ready(function () {
                    $(".logs-table").DataTable({
                        destroy: true,
                        ordering: false,
                        lengthChange:false,
                        language: {
                            search: "_INPUT_",
                            searchPlaceholder: "18:12:00, /wp-content/upload",
                            emptyTable: "No PHP Error Logs Present At This Time",
                            size: '50'
                        }
                    });
                    $("#logsTableSection .dataTables_filter input").attr('size', 50);
                    $("#logsTableSection .dataTables_filter label").prepend('Search: ');
                    $("#logsTableSection .dataTables_filter").addClass('mt-3');
                    $("#logsTableSection .dataTables_filter").parent().prev().append('<button class="btn btn-primary btn-mini refresh-btn" type="button"><i class="fa fa-refresh"></i> Refresh Logs</button>');
                    $(".refresh-btn").click(() => {
                        self.fetchLogs();
                    })
                });
                /* eslint-enable */
            }
        }
    }
</script>

<style scoped>
    .logs-table tr td {
        font-size: 16px;
        padding: 15px;
    }
    .logs-table thead {
        display: none !important;
    }
    .refresh-btn{
        margin-top: 0 !important;
    }
    .logs-select {
        padding: 0 0 0 10px;
    }
</style>
